import { render } from "./ExpenseSummary.vue?vue&type=template&id=06a33438&scoped=true"
import script from "./ExpenseSummary.vue?vue&type=script&lang=js"
export * from "./ExpenseSummary.vue?vue&type=script&lang=js"

import "./ExpenseSummary.vue?vue&type=style&index=0&id=06a33438&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a33438"]])

export default __exports__